module.exports = [{"type":"title","text":"2025-06-30"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: Added displayName field to 'USDT-M Perp Futures symbols' interface."},{"type":"html","text":"Coin-M Perp Futures: Added displayName field to 'Contract Information' interface."},{"type":"html","text":"Spot: Added displayName field to 'Spot trading symbols' interface."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-06-30.json
// module id = EwTG
// module chunks = 3